import { render, staticRenderFns } from "./StatusCard.vue?vue&type=template&id=4a61e95a"
import script from "./StatusCard.vue?vue&type=script&lang=js"
export * from "./StatusCard.vue?vue&type=script&lang=js"
import style0 from "./StatusCard.vue?vue&type=style&index=0&id=4a61e95a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports